import Swal from 'sweetalert2'
import i18n from '../i18n'

/**
 * Onde a falha vira coisa que o usuário vê.
 *
 * Separado do `http.js` de propósito: o interceptor sabe CLASSIFICAR o erro, e
 * este módulo sabe MOSTRAR. Trocar o sweetalert por um snackbar do Vuetify
 * amanhã mexe só aqui.
 *
 * `sweetalert2` é importado direto, e não pelo `this.$swal`: o interceptor roda
 * fora de qualquer componente e não tem `this`. O pacote já é dependência do
 * projeto — não entra nada novo.
 */

/**
 * Toast, e não modal.
 *
 * O modal do sweetalert bloqueia a tela e exige clique. Numa listagem que
 * dispara várias requisições, isso empilharia caixas por cima do conteúdo. O
 * toast informa sem interromper, e é o comportamento certo para erro que o
 * usuário não pediu para ver.
 */
export function mostrarErro (problema) {
  // Sessão expirada não vira toast: quem trata é o interceptor, que limpa o
  // token e leva ao login. Um aviso dizendo "sua sessão expirou" enquanto a
  // tela já mudou é ruído.
  if (problema.exigeReautenticacao) return

  Swal.fire({
    toast: true,
    position: 'top-end',
    // SweetAlert2 v11 usa `icon`; `type` foi removido — o mesmo tropeço que já
    // apareceu no games.vue.
    icon: 'error',
    title: problema.mensagem,
    showConfirmButton: false,
    timer: 6000,
    timerProgressBar: true,
    // Sem isto, dois erros seguidos fazem o segundo substituir o primeiro no
    // meio da leitura.
    didOpen: toast => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
}

/**
 * Aviso de sessão morta, mostrado ANTES de mandar para o login.
 *
 * Aqui é modal, e não toast: a tela vai mudar debaixo do usuário, e ele precisa
 * entender por quê. Um toast que aparece junto com a troca de rota passa
 * despercebido.
 */
export function avisarSessaoExpirada () {
  Swal.fire({
    icon: 'warning',
    title: i18n.global.t('erros.sessao_expirada'),
    confirmButtonText: i18n.global.t('erros.entrar')
  })
}
